import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export default function Sidebar({ selected, components }) {
  return (
    <List data-testid="componentList">
      {components.map(item => (
        <Link to={`/components/${item.id}`} key={item.id}>
          <Menu selected={selected === item.id}>
            {item.name} {item.zhName}
          </Menu>
        </Link>
      ))}
    </List>
  )
}

const List = styled.ul`
  height: 100vh;
  min-width: 10%;
  padding-left: 0;
  a {
    color: black;
    text-decoration: none;
    text-transform: capitalize;
  }
`
const Menu = styled.li`
  list-style: none;
  border: 1px solid gray;
  padding: 10px 12px;
  background: ${({ selected }) => (selected ? 'gray' : 'white')}
  
  :hover {
    background: gray;
  }
`
